import {logInProduction} from '$lib/utils/logInProduction';

export class RemoteChanges {

    private _current = $state(false)

    get current() {
        return this._current
    }

    constructor(
        private disconnectAccount: () => void,
    ) {}

    detected() {
        logInProduction('RemoteChanges detected')
        this._current = true
        // QUESTION calling onLogout here appropriate?
        this.disconnectAccount()
    }
}